import { gql } from '@apollo/client'

import { CUSTOMER_FRAGMENT } from '../fragments'
import { CUSTOMER_ADDRESS_FRAGMENT } from '../fragments/customer/address'
import { SHOP_CUSTOMER_SPREEDLY_CARD_FRAGMENT } from '../fragments/shop/customerSpreedlyCard'
import { SHOP_SQUARE_CUSTOMER_CARD_FRAGMENT } from '../fragments/shop/squareCustomerCard'

export const GET_CURRENT_CUSTOMER = gql`
  query CurrentCustomer {
    currentCustomer {
      ...Customer
    }
  }
  ${CUSTOMER_FRAGMENT}
`

export const GET_CURRENT_CUSTOMER_CHECKOUT = gql`
  query CurrentCustomerCheckout {
    currentCustomer {
      ...Customer
      addresses {
        ...CustomerAddress
      }
      spreedlyCards {
        ...CustomerSpreedlyCard
      }
      squareCards {
        ...ShopSquareCustomerCard
      }
    }
  }
  ${CUSTOMER_FRAGMENT}
  ${CUSTOMER_ADDRESS_FRAGMENT}
  ${SHOP_CUSTOMER_SPREEDLY_CARD_FRAGMENT}
  ${SHOP_SQUARE_CUSTOMER_CARD_FRAGMENT}
`
